/* customeclat: synchronizacja wariantu do formularza dynamic checkout (Shop Pay / Buy with Shop).
   Problem: Prestige przy zmianie wariantu aktualizuje input [name="id"] tylko w formularzu
   form.shopify-product-form (i robi to BEZ zdarzenia change), a Shopify renderuje przycisk
   płatności w OSOBNYM formularzu (form.shopify-payment-form) o tym samym atrybucie id.
   Jego input zostawał na wariancie z załadowania strony, przez co dynamic checkout kupował
   zły wariant. Przycisk płatności jest w iframe, więc nie da się też przechwycić kliknięcia.
   Fix: lekki interwał kopiujący wartość z formularza produktowego do sparowanego (to samo id)
   formularza płatności — wzorzec spójny z istniejącymi skryptami motywu (top10, accordion). */
(function () {
  function syncAll() {
    var productForms = document.querySelectorAll('form.shopify-product-form[action*="/cart/add"]');
    productForms.forEach(function (pf) {
      /* UWAGA: form.id jest przesłonięte przez kontrolkę <input name="id"> —
         atrybut id trzeba czytać przez getAttribute. */
      var pfId = pf.getAttribute("id");
      if (!pfId) return;
      var src = pf.querySelector('input[name="id"]');
      if (!src || !src.value) return;
      document.querySelectorAll("form.shopify-payment-form").forEach(function (payf) {
        if (payf.getAttribute("id") !== pfId) return;
        var dst = payf.querySelector('input[name="id"]');
        if (dst && dst.value !== src.value) dst.value = src.value;
      });
    });
  }
  setInterval(syncAll, 400);
  document.addEventListener(
    "change",
    function () {
      setTimeout(syncAll, 50);
      setTimeout(syncAll, 600);
    },
    true
  );
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll);
  } else {
    syncAll();
  }
})();
